<template>
    <footer class="footer">
        <!-- 四个板块容器 -->
        <div class="footer-content">
            <!-- 数据资产全过程管理平台 -->
            <div class="footer-section">
                <h3>
                    <img style="width: 40px;" src="../../public/logo.png" alt="logo" />
                    数据资产全过程AI服务平台
                </h3>
                <p>建立数据资产全过程体系<br />助力企业数据价值变现</p>
            </div>

            <!-- 快捷入口 -->
            <div class="footer-section">
                <h3>快捷入口</h3>
                <ul>
                    <li><a href="/">平台简介</a></li>
                    <li><a href="/websiteFAQ">常见问题</a></li>
                    <li><a href="/about">联系我们</a></li>
                </ul>
            </div>

            <!-- 登记服务 -->
            <div class="footer-section">
                <h3>登记服务</h3>
                <ul>
                    <li><a href="#">指引手册</a></li>
                    <li><a href="#">政策法规</a></li>
                    <li><a href="#">反馈意见</a></li>
                </ul>
            </div>

            <!-- 商务合作 -->
            <div class="footer-section">
                <h3>商务合作</h3>
                <ul>
                    <li><a>咨询电话：15831289727</a></li>
                    <li><a>地址：保定市竞秀区数字大厦一楼 </a></li>

                    <li><a>邮箱：yuanshuqiang@xinxiushuzi.com </a></li>
                </ul>
            </div>


            <!-- 二维码 -->
            <div class="footer-section qr-code">
                <div class="qr-container">
                    <div class="qr-image-wrapper" @click="showQrModal = true">
                        <img src="../assets/shipinhao.jpg" alt="微信公众号二维码" class="qr-image" />
                    </div>
                    <p>关注微信视频号<br />了解最新登记政策</p>
                </div>
            </div>
        </div>

        <!-- 版权信息 -->
        <div class="footer-copyright">
            <p>冀ICP备2025125156号-1</p>
            <p>© 2025 数据资产全过程AI服务平台 版权所有 隐私政策</p>
        </div>

        <!-- 二维码预览模态框 -->
        <div v-if="showQrModal" class="qr-modal" @click="showQrModal = false">
            <div class="qr-modal-content" @click.stop>
                <button class="qr-modal-close" @click="showQrModal = false">×</button>
                <div class="qr-modal-image-wrapper">
                    <img src="../assets/shipinhao.jpg" alt="微信视频号二维码" class="qr-modal-image" />
                </div>
                <p class="qr-modal-text">扫描二维码关注微信视频号</p>
            </div>
        </div>



    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            showQrModal: false
        }
    }
}
</script>

<style scoped lang="scss">
// 定义颜色变量
$primary-color: #245A97;
$text-color: white;
$link-color: #ccc;
$hover-color: #fff;
$copyright-color: #aaa;
$qr-bg: white;
$qr-border: #333;
$qr-logo-color: #07c160;

.footer {
    background-color: $primary-color;
    color: $text-color;
    padding: 40px 20px;
    font-family: Arial, sans-serif;
    position: relative;

    &-content {
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        justify-content: space-between;
        max-width: 1200px;
        margin: 0 auto;
    }

    &-section {
        flex: 1 1 250px;
        min-width: 200px;
        text-align: center;

        h3 {
            font-size: 18px;
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            justify-content: center; // 添加这行让内容水平居中
            gap: 8px;
        }

        p {
            font-size: 14px;
            line-height: 1.6;
            margin: 0;
        }

        ul {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
                margin-bottom: 8px;

                a {
                    color: $link-color;
                    text-decoration: none;
                    font-size: 14px;

                    &:hover {
                        color: $hover-color;
                        text-decoration: underline;
                    }
                }
            }
        }

        &.qr-code {
            display: flex;
            justify-content: center;
            align-items: center;

            .qr-container {
                text-align: center;

                p {
                    text-align: center;
                    font-size: 12px;
                    line-height: 1.4;
                    margin-top: 8px;
                    color: $link-color;
                }

                .qr-image-wrapper {
                    position: relative;
                    width: 120px;
                    height: 120px;
                    margin: 0 auto 10px;
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    background: $qr-bg;
                    cursor: pointer;
                    transition: transform 0.2s ease, box-shadow 0.2s ease;

                    &:hover {
                        transform: scale(1.05);
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    }

                    .qr-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .qr-logo-overlay {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 30px;
                        height: 30px;
                        background: $qr-bg;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
                    }
                }
            }
        }
    }

    &-copyright {
        text-align: center;
        margin-top: 30px;
        font-size: 12px;
        color: $copyright-color;
    }
}

// 二维码预览模态框样式
.qr-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease;

    &-content {
        background: white;
        border-radius: 12px;
        padding: 30px;
        position: relative;
        max-width: 90%;
        max-height: 90%;
        animation: slideUp 0.3s ease;
    }

    &-close {
        position: absolute;
        top: 10px;
        right: 15px;
        background: none;
        border: none;
        font-size: 28px;
        color: #666;
        cursor: pointer;
        line-height: 1;
        padding: 0;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: color 0.2s ease;

        &:hover {
            color: #333;
        }
    }

    &-image-wrapper {
        width: 300px;
        height: 300px;
        margin: 0 auto 20px;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

        .qr-modal-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &-text {
        text-align: center;
        color: #333;
        font-size: 16px;
        margin: 0;
        font-weight: 500;
    }
}

// 动画
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// 响应式调整
@media (max-width: 768px) {
    .footer {
        &-content {
            flex-direction: column;
            gap: 20px;
        }

        &-section {
            flex: 1 1 100%;
            min-width: auto;

            h3 {
                font-size: 16px;
                justify-content: center; // 响应式下也保持居中
            }

            p,
            ul li a {
                font-size: 13px;
            }

            &.qr-code {
                .qr-container {
                    .qr-image-wrapper {
                        width: 100px;
                        height: 100px;

                        .qr-logo-overlay {
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
            }
        }
    }

    .qr-modal {
        &-content {
            padding: 20px;
        }

        &-image-wrapper {
            width: 250px;
            height: 250px;
        }

        &-text {
            font-size: 14px;
        }
    }
}

@media (max-width: 480px) {
    .qr-modal {
        &-image-wrapper {
            width: 200px;
            height: 200px;
        }
    }
}
</style>